import { LAYOUTS, MENU_SECTIONS, USER_ROLES } from "shared/constants";
import type { AppRouteRecordRaw } from "shared/types";

/** Webmaster AI-prompt management page, spliced into the webmaster route children. */
export const manageAiPromptsRouteFragment: AppRouteRecordRaw = {
  path: "ai-prompts",
  name: "manageAiPrompts",
  component: () => import("manage-ai-prompts/pages/ManageAiPromptsPage.vue"),
  meta: {
    title: "AI-prompts",
    roleRequired: [USER_ROLES.WEBMASTER],
    isMenuItem: true,
    menuSection: MENU_SECTIONS.MANAGE,
    layout: LAYOUTS.MAIN_NO_WRAPPER,
  },
  children: [
    {
      path: ":aiAssistantId",
      name: "manageAiPromptDetail",
      component: () =>
        import("manage-ai-prompts/pages/ManageAiPromptDetailPage.vue"),
      meta: {
        title: "AI-prompt",
        roleRequired: [USER_ROLES.WEBMASTER],
        menuSection: MENU_SECTIONS.MANAGE,
        hideTitle: true,
      },
    },
  ],
};
